module.exports = __webpack_public_path__ + "img/Follow_the_Instructions_on_the_Bottle.92dbcfc3.png";